export const CANVAS_TREATMENTS = [
  "Canvas on Stretcher",
  "Canvas in Floater Frame",
  // Staff only (09-22): loose (unstretched, rolled) canvas — priced on the sheet's loose tier, no stretcher.
  "Loose Canvas",
];

export const CANVAS_EDGE_OPTIONS = ["Mirror image", "Border color"];

export const CANVAS_FRAME_TYPES = [
  {
    dimensions: {
      depth: 1.125,
      face: 0.75,
    },
    label: "Black Floater Frame",
    sizes: {
      "canvas-in-floater-frame": 32,
      "canvas-on-stretcher": 57,
    },
    texture: {
      face: "black",
      hex: "#333333",
      preview: "black",
      side: "black",
    },
    description: {
      "in-floater-frame":
        'Solid wood, matte black finish. 7/16" face, 2" deep from wall.',
    },
    url: "/content/frames/canvas-hdalu/black-floater.png",
  },
  {
    dimensions: {
      depth: 1.125,
      face: 0.75,
    },
    label: "White Floater Frame",
    sizes: {
      "canvas-in-floater-frame": 32,
      "canvas-on-stretcher": 57,
    },
    texture: {
      face: "white",
      hex: "#fffffe",
      preview: "white",
      side: "white",
    },
    description: {
      "in-floater-frame":
        'Solid wood, matte white finish. 7/16" face, 2" deep from wall.',
    },
    url: "/content/frames/canvas-hdalu/white-floater.png",
  },
  {
    dimensions: {
      depth: 1.4375,
      face: 0.75,
    },
    label: "Weathered Walnut Floater Frame",
    sizes: {
      "canvas-in-floater-frame": 32,
      "canvas-on-stretcher": 57,
    },
    texture: {
      face: "weathered",
      hex: "",
      preview: "weathered",
      side: "weathered",
    },
    description: {
      "in-floater-frame":
        'Solid wood, slightly distressed warm walnut finish with visible wood grain. 7/16" face, 2" deep from wall.',
    },
    url: "/content/frames/canvas-hdalu/weathered-walnut-floater.png",
  },
  {
    dimensions: {
      depth: 1.4375,
      face: 0.75,
    },
    label: "Weathered Gray Floater Frame",
    sizes: {
      "canvas-in-floater-frame": 32,
      "canvas-on-stretcher": 57,
    },
    texture: {
      face: "weathered",
      hex: "",
      preview: "weathered",
      side: "weathered",
    },
    description: {
      "in-floater-frame":
        'Solid wood, slightly distressed warm walnut finish with visible wood grain. 7/16" face, 2" deep from wall',
    },
    url: "/content/frames/canvas-hdalu/weathered-gray-floater.png",
  },
  {
    dimensions: {
      depth: 1.4375,
      face: 0.75,
    },
    label: "Weathered Black Floater Frame",
    sizes: {
      "canvas-in-floater-frame": 32,
      "canvas-on-stretcher": 57,
    },
    texture: {
      face: "weathered",
      hex: "",
      preview: "weathered",
      side: "weathered",
    },
    description: {
      "in-floater-frame":
        'Solid wood, slightly distressed rich black finish with visible wood grain. 7/16" face, 2" deep from wall.',
    },
    url: "/content/frames/canvas-hdalu/weathered-black-floater.png",
  },
  {
    dimensions: {
      depth: 1.4375,
      face: 0.75,
    },
    label: "Weathered White Floater Frame",
    sizes: {
      "canvas-in-floater-frame": 32,
      "canvas-on-stretcher": 57,
    },
    texture: {
      face: "weathered",
      hex: "",
      preview: "weathered",
      side: "weathered",
    },
    description: {
      "in-floater-frame":
        'Solid wood, slightly distressed white finish with visible wood grain. 7/16" face, 2" deep from wall.',
    },
    url: "/content/frames/canvas-hdalu/weathered-white-floater.png",
  },

  {
    dimensions: {
      depth: 1.4375,
      face: 0.75,
    },
    label: "Dark Walnut Floater Frame",
    sizes: {
      "canvas-in-floater-frame": 32,
      "canvas-on-stretcher": 57,
    },
    texture: {
      face: "weathered",
      hex: "",
      preview: "weathered",
      side: "weathered",
    },
    description: {
      "in-floater-frame":
        'Solid wood, rich dark walnut finish with visible wood grain. 7/16" face, 1-7/8" deep from wall.',
    },
    url: "/content/frames/canvas-hdalu/dark-walnut-floater.png",
  },

  {
    dimensions: {
      depth: 1.125,
      face: 0.75,
    },
    label: "Gold Floater Frame",
    sizes: {
      "canvas-in-floater-frame": 32,
      "canvas-on-stretcher": 57,
    },
    texture: {
      face: "metallic",
      hex: "#000000",
      preview: "metallic",
      side: "metallic",
    },
    description: {
      "in-floater-frame":
        'Solid wood, metallic gold finish. 7/16" face, 1-7/8" deep from wall.',
    },
    url: "/content/frames/canvas-hdalu/gold-floater.png",
  },

  {
    dimensions: {
      depth: 1.125,
      face: 0.75,
    },
    label: "Silver Floater Frame",
    sizes: {
      "canvas-in-floater-frame": 32,
      "canvas-on-stretcher": 57,
    },
    texture: {
      face: "metallic",
      hex: "#000000",
      preview: "metallic",
      side: "metallic",
    },
    description: {
      "in-floater-frame":
        'Solid wood, metallic silver finish. 7/16" face, 1-7/8" deep from wall.',
    },
    url: "/content/frames/canvas-hdalu/silver-floater.png",
  },
];

export const BORDER_COLORS = [
  {
    hex: "#fff",
    label: "White",
  },
  {
    hex: "#000",
    label: "Black",
  },
  {
    hex: "#fff",
    label: "Pick",
  },
];
